import SmallEditIcon from './component.jsx'
export default SmallEditIcon
